import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetSuitableCollection = (projectId: string) => {

    const [collection, setCollection] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        if (projectId) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Collection/GetSuitableCollectionForProject')
                .addQuery('id', projectId)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setIsLoading(false);
                    setCollection(r)
                })
                .catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
        }
    }, [projectId])

    return {collection: API.toLang(collection, 'en') as any, isLoading, error}
}import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetSuitableCollection = (projectId: string) => {

    const [collection, setCollection] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        if (projectId) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Collection/GetSuitableCollectionForProject')
                .addQuery('id', projectId)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setIsLoading(false);
                    setCollection(r)
                })
                .catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
        }
    }, [projectId])

    return {collection: API.toLang(collection, 'en') as any, isLoading, error}
}